import React, { Component, PropTypes } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import _ from 'lodash';
import moment from 'moment';

class VideoLibrary extends Component {
  constructor() {
    super();

    this.updateSelected = this.updateSelected.bind(this);
  }

  updateSelected(selectedRows) {
    const selected = _.map(selectedRows, rowIndex => {
      return this.props.videos[rowIndex];
    });

    this.props.onSelected(selected);
  }

  render() {
    return (
      <div>
        <Table onRowSelection={this.updateSelected} multiSelectable={true}>
          <TableHeader displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>名稱</TableHeaderColumn>
              <TableHeaderColumn>上載日期</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody deselectOnClickaway={false}>
            {
              _.map(this.props.videos, (video, index) =>
                <TableRow key={index}
                          selected={!!_.find(this.props.selected, { _id: video._id })}>
                  <TableRowColumn>{video.title}</TableRowColumn>
                  <TableRowColumn>{moment(video.createdAt).format('DD/MM/YYYY HH:mm:ss')}</TableRowColumn>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </div>
    )
  }
}

VideoLibrary.propTypes = {
  videos: PropTypes.array,
  selected: PropTypes.array,
  onSelected: PropTypes.func,
};

VideoLibrary.defaultProps = {
  videos: [],
  selected: [],
  onSelected: () => {
  },
};

export default VideoLibrary;


// WEBPACK FOOTER //
// client/adminPanel/panel/displays/VideoLibrary.js